// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_e-0";
export var skeletonCard = "_e-1";